<script setup>
const { authUser, logout, isAuthenticated, stopEmulation, emulatedUserId } = useAuth()
const { $notify } = useNuxtApp()
import { startCase } from 'lodash'
import { differenceInDays, startOfDay } from 'date-fns';

const emit = defineEmits(['toggleSidebar'])
const router = useRouter()

const { hasFilters } = useFilters()

const data = reactive({
    document: null,
    forceChangePassword: false
})

const openChangePassword = ref()

const password_expire = authUser.value?.account?.password_expire

if (password_expire) {
  const password_expire_date = new Date(password_expire)
  const today = new Date()
  const in_ten_days = new Date()
  in_ten_days.setDate(today.getDate() + 10)
  
  if (password_expire_date<today) {
    openChangePassword.value = true
    data.forceChangePassword = true
  } else if (password_expire_date<in_ten_days) {
    const days = differenceInDays(
      startOfDay(password_expire_date),
      startOfDay(today)
    )
    nextTick(() => $notify(`Your password is expiring in ${days} days, please change it.`, 'warning'))
  }
}

if (password_expire && new Date(password_expire)<new Date()) {
  openChangePassword.value = true
  data.forceChangePassword = true
}

import links from './settings'


function stopEmulationAndRefresh() {
      stopEmulation()
      router.push(`/dashboard`)
      // location.assign('/#/dashboard')
      location.reload() // Altrimenti la dashboard non ricarica le cose giuste....
}

</script>
<template>
  <v-app-bar app color="primary" v-if="isAuthenticated">
    <AppChangePassword v-model="openChangePassword" :force="data.forceChangePassword"/>

    <v-app-bar-nav-icon @click="emit('toggleSidebar')"/>
    <v-toolbar-title variant="primary">
      <strong>{{ startCase($route?.meta?.title ?? $route?.name ?? '') }}</strong>
    </v-toolbar-title>

    <v-btn dark variant="flat" class="mr-5" v-if="emulatedUserId" color="red" @click="stopEmulationAndRefresh">ATTENTION! You are in user emulation mode. Click to CANCEL</v-btn>
    
    
    <CoreSearchDocumentSchema id="globalSearchDocument" v-if='hasFilters' v-model="data.document" navbar class="mr-2" style="width: 400px;" clearable/>
    <v-btn id="buttonToolbar_settings" v-show='$can("read", "global_settings")' class='mr-1' icon='mdi-cog' />
    <v-tooltip text="Tutorial" location="bottom">
      <template #activator="{ props }">
        <v-btn v-bind="props" id="buttonToolbar_tutorial" class='mr-1' icon='mdi-help-circle-outline' to="/tutorial"></v-btn>
      </template>
    </v-tooltip>
    <v-btn id="buttonToolbar_menu" append-icon='mdi-user'  size="large">{{ authUser?.account?.name }}</v-btn>

    <v-menu activator="#buttonToolbar_settings" bottom left offset-y transition="slide-y-transition">
      <v-card width="250" variant='outlined' color='grey-lighten-2'>
          <v-list>
            <v-list-item :id="`button_setting_${link.entity}`" v-for="(link, id) in links" :key="id" :title="link.text" :to="link.to"
              :prepend-icon="link?.icon" />
          </v-list>
      </v-card>
    </v-menu>    
    
    <v-menu activator="#buttonToolbar_menu" bottom left offset-y transition="slide-y-transition">
      <v-card width="250" variant='outlined' color='grey-lighten-2'>
        <v-list>
          <v-list-item>
            <v-list-item-title>{{ authUser.account.name }} {{ authUser.account.surname }}</v-list-item-title>
            <v-list-item-subtitle>[{{ authUser.account.system_role }}]</v-list-item-subtitle>
          </v-list-item>
          <v-list-item id="button_change_password" @click="openChangePassword = true" prepend-icon="mdi-key">Change password</v-list-item>
          <v-list-item id="button_logout" @click="logout" prepend-icon="mdi-logout">Logout</v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>  
  
